import Box from "@mui/material/Box";
import MyToastShow from "@/components/Layout/MyToast";
import TablaInformes from "@/components/Tablas/TablaInformes/TablaInformes";
import TopWrapper from "@/pages/Dashboard/DashboardLayout/TopWrapper";
import { useState } from "react";
import { informeApi } from "@/redux/api/informeApi";
import { IInforme, IUser } from "@/redux/models";
import NavFiltros from "./NavFiltros";

const FiltrarInformesPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [informes, setInformes] = useState<IInforme[]>([]);
  const [hideKeys] = useState<any[]>([
    "ACTION_LIQUIDAR",
    "ACTION_RESTAURAR",
    "ACTION_EDITAR",
  ]);

  const [obtenerInformesFiltrados] = informeApi.endpoints.obtenerInformesFiltrados.useLazyQuery();

  const [selectedUser, setSelectedUser] = useState<IUser>();

  const handleFiltrar = async (query: any) => {
    setIsLoading(true);

    try {
      const response = await obtenerInformesFiltrados(query).unwrap()
      setInformes(response)
      if (query.userId) {
        setSelectedUser(response[0]?.usuario)
      } else {
        setSelectedUser(undefined)
      }
    }
    catch (error: any) {
      setInformes([])
      console.error('Error al obtener informes filtrados:', error);
      MyToastShow({ message: error.data?.message || 'No se encontraron informes', type: 'error' })
    }
    finally {
      setIsLoading(false)
    }
  }
  
  return (
    <>
      <TopWrapper
        title="Filtrar Informes"
        subtitle="Buscá los informes con ciertos parámetros"
      />

      <Box
        sx={{
          maxWidth: "1200px",
          margin: "0 auto",
          mb: "40px",
        }}
      >
        <NavFiltros onSubmit={handleFiltrar} />

        <TablaInformes
          isLoading={isLoading}
          informes={informes}
          selectedUser={selectedUser}
          onPageChange={function (page: number): Promise<void> {
            throw new Error("Function not implemented.");
          }}
          totalInformes={999999}
          rowsPerPage={999999}
          hideColumns={hideKeys}
        />
      </Box>
    </>
  );
};

export default FiltrarInformesPage;